export default __webpack_public_path__ + "static/media/step4.038fb57c.webp";